import store from '@/store';
import { v4 as uuidv4 } from 'uuid';
import DeviceType from './DeviceType';
import Requests from './Request';
import StorageHandler from '@/helpers/StorageHandler';
import CookieStorage from './StorageHandler/CookieStorage';
import Device from './Device';
import DeviceFingerprint from './fingerprint';

const ID = {
  bid: 'bid',
  deviceId: 'device_id',
  room: 'room',
  serialNumber: 'serial_number',
  lang: 'lang'
};

const defaultOptions = {
  bid: true,
  deviceId: true,
  room: true,
  serialNumber: true,
  lang: true
};

//console.log("====================hcap0", hcap);
//console.log("====================window", window.hcap);
//console.log("====================lg", lg);

const tizen = window.tizen;
if(typeof hcap != "undefined") {
  const lg = window.hcap;
} else {
  const lg = {};
}
const orsay = window.orsay;

const isValueDefined = (value) => {
  if (value === undefined) return false;
  if (value === null) return false;
  if (value === 'undefined') return false;
  if (value === 'null') return false;
  return true;
};

class Registration {
  static async getUniqueId() {
    return await Device.serialNumber;
  }

  /**
   * Local Storage
   */

  static getLocalStorageValueByName(name) {
    return localStorage.getItem(name);
  }

  static setLocalStorageValueByName(name, value) {
    localStorage.setItem(name, value);
  }

  static removeLocalStorageValueByName(name) {
    localStorage.removeItem(name);
  }

  // ALL
  static get getLocalStorage() {
    return {
      bid: this.getLocalStorageValueByName(ID.bid),
      deviceId: this.getLocalStorageValueByName(ID.deviceId),
      room: this.getLocalStorageValueByName(ID.room),
    };
  }
  static saveLocalStorageData({ bid, deviceId, room, serialNumber }) {
    if (bid) this.setLocalStorageValueByName(ID.bid, bid);
    if (deviceId) this.setLocalStorageValueByName(ID.deviceId, deviceId);
    if (room) this.setLocalStorageValueByName(ID.room, room);
    if (serialNumber) this.setLocalStorageValueByName(ID.serialNumber, serialNumber);
  }
  static removeLocalStorageData(options = defaultOptions) {
    if (options.bid) this.removeLocalStorageValueByName(ID.bid);
    if (options.deviceId) this.removeLocalStorageValueByName(ID.deviceId);
    if (options.room) this.removeLocalStorageValueByName(ID.room);
    if (options.serialNumber) this.removeLocalStorageValueByName(ID.serialNumber);
    if (options.lang) this.removeLocalStorageValueByName(ID.lang);
  }

  /**
   *	Tizen
   */

  static getTizenStorageInfoByName(name) {
    try {
      const value = tizen.keymanager.getData({ name });
      return value;
    } catch (error) {
      console.log(
        `Couldn't find tizen ${name} inf storage, because of Error: ${error.name} with Error Message: ${error.message}`
      );
      return undefined;
    }
  }
  static getLGStorageInfoByName(name) {
    try {
      //const value = lg.keymanager.getData({ name });
      //const value = this.getLocalStorageValueByName({ name });
      const value = StorageHandler.get({ name });
      return value;
    } catch (error) {
      console.log(
        `Couldn't find lg ${name} inf storage, because of Error: ${error.name} with Error Message: ${error.message}`
      );
      return undefined;
    }
  }
  static getOrsayStorageInfoByName(name) {
    try {
      const value = orsay.keymanager.getData({ name });
      return value;
    } catch (error) {
      console.log(
        `Couldn't find orsay ${name} inf storage, because of Error: ${error.name} with Error Message: ${error.message}`
      );
      return undefined;
    }
  }

  static setTizenStorageInfoByName(name, value) {
    try {
      tizen.keymanager.saveData(name, value, null, this.submitCallback);
    } catch (error) {
      store.dispatch('notification/new', {
        title: 'Save data ' + name,
        message: value,
      });
      console.log('Could not save by name Id: ', name, value, error);
    }
  }
  static removeTizenStorageInfoByName(name) {
    try {
      tizen.keymanager.removeData({ name });
      StorageHandler.remove({ name });
    } catch (error) {
      console.log('Could not remove by name: ', name, error);
    }
  }

  static setLGStorageInfoByName(name, value) {
    try {
      //tizen.keymanager.saveData(name, value, null, this.submitCallback);
      //this.setLocalStorageValueByName({ name, value });
      StorageHandler.save({ name, value });
    } catch (error) {
      store.dispatch('notification/new', {
        title: 'Save data ' + name,
        message: value,
      });
      console.log('Could not save by name Id: ', name, value, error);
    }
  }
  static removeLGStorageInfoByName(name) {
    try {
      //tizen.keymanager.removeData({ name });
      //this.removeLocalStorageValueByName({ name });
      StorageHandler.remove({ name });
    } catch (error) {
      console.log('Could not remove by name: ', name, error);
    }
  }

  static submitCallback(context) {
    console.log('SUBMIT CALLBACK: ', context);
    store.dispatch('notification/new', {
      title: 'Tizen Saved data ',
      message: JSON.stringify(context),
    });
  }

  static get getTizenData() {
    return {
      bid: this.getTizenStorageInfoByName(ID.bid),
      deviceId: this.getTizenStorageInfoByName(ID.deviceId),
      room: this.getTizenStorageInfoByName(ID.room),
    };
  }
  static get getLGData() {
    return {
      bid: this.getLGStorageInfoByName(ID.bid),
      deviceId: this.getLGStorageInfoByName(ID.deviceId),
      room: this.getLGStorageInfoByName(ID.room),
    };
  }
  static get getOrsayData() {
    return {
      bid: this.getOrsayStorageInfoByName(ID.bid),
      deviceId: this.getOrsayStorageInfoByName(ID.deviceId),
      room: this.getOrsayStorageInfoByName(ID.room),
    };
  }

  static removeTizenBuildingId() {
    try {
      tizen.keymanager.removeData({ name: ID.bid });
      StorageHandler.remove({ name: ID.bid });
    } catch (error) {
      console.log('Could not remove building Id: ', ID.bid, error);
    }
  }
  static removeLGBuildingId() {
    try {
      //lg.keymanager.removeData({ name: ID.bid });
      StorageHandler.remove({ name: ID.bid });
    } catch (error) {
      console.log('Could not remove building Id: ', ID.bid, error);
    }
  }
  static removeOrsayBuildingId() {
    try {
      //orsay.keymanager.removeData({ name: ID.bid });
      StorageHandler.remove({ name: ID.bid });
    } catch (error) {
      console.log('Could not remove building Id: ', ID.bid, error);
    }
  }
  static handleSaveTizenData({ bid, deviceId, room, serialNumber }) {
    if (bid) this.setTizenStorageInfoByName(ID.bid, bid);
    if (deviceId) this.setTizenStorageInfoByName(ID.deviceId, deviceId);
    if (room) this.setTizenStorageInfoByName(ID.room, room);
    if (serialNumber) this.setTizenStorageInfoByName(ID.serialNumber, serialNumber);
  }
  static handleSaveLGData({ bid, deviceId, room, serialNumber }) {
    if (bid) this.setLGStorageInfoByName(ID.bid, bid);
    if (deviceId) this.setLGStorageInfoByName(ID.deviceId, deviceId);
    if (room) this.setLGStorageInfoByName(ID.room, room);
    if (serialNumber) this.setLGStorageInfoByName(ID.serialNumber, serialNumber);
  }
  static handleSaveOrsayData({ bid, deviceId, room, serialNumber }) {
    if (bid) this.setOrsayStorageInfoByName(ID.bid, bid);
    if (deviceId) this.setOrsayStorageInfoByName(ID.deviceId, deviceId);
    if (room) this.setOrsayStorageInfoByName(ID.room, room);
    if (serialNumber) this.setOrsayStorageInfoByName(ID.serialNumber, serialNumber);
  }

  static removeTizenData(options = defaultOptions) {
    if (options.bid) {
      this.removeTizenStorageInfoByName(ID.bid);
    }
    if (options.deviceId) {
      this.removeTizenStorageInfoByName(ID.deviceId);
    }
    if (options.room) {
      this.removeTizenStorageInfoByName(ID.room);
    }
    if (options.serialNumber) {
      this.removeTizenStorageInfoByName(ID.serialNumber);
    }
    if (options.lang) {
      this.removeTizenStorageInfoByName(ID.lang);
    }
  }
  static removeLGData(options = defaultOptions) {
    if (options.bid) {
      this.removeLGStorageInfoByName(ID.bid);
    }
    if (options.deviceId) {
      this.removeLGStorageInfoByName(ID.deviceId);
    }
    if (options.room) {
      this.removeLGStorageInfoByName(ID.room);
    }
    if (options.serialNumber) {
      this.removeLGStorageInfoByName(ID.serialNumber);
    }
    if (options.lang) {
      this.removeLGStorageInfoByName(ID.lang);
    }
  }
  static removeOrsayData(options = defaultOptions) {
    if (options.bid) {
      this.removeOrsayStorageInfoByName(ID.bid);
    }
    if (options.deviceId) {
      this.removeOrsayStorageInfoByName(ID.deviceId);
    }
    if (options.room) {
      this.removeOrsayStorageInfoByName(ID.room);
    }
    if (options.serialNumber) {
      this.removeOrsayStorageInfoByName(ID.serialNumber);
    }
    if (options.lang) {
      this.removeOrsayStorageInfoByName(ID.lang);
    }
  }

  static async saveData({ bid, deviceId, room, serialNumber }) {
    const SERIAL_NUMBER = isValueDefined(serialNumber)
      ? serialNumber
      : await this.getUniqueId();

    const context = {
      bid,
      deviceId,
      room,
      serialNumber: SERIAL_NUMBER,
    };

    if(DeviceType.isTizen) {
      console.log("=======================setTizenData", context);
      this.handleSaveTizenData(context);
    }
    if(DeviceType.isLG) {
      console.log("=======================setLGData", context);
      //this.handleSaveLGData(context);
      this.saveLocalStorageData(context);
    }
    if(DeviceType.isOrsay) {
      console.log("=======================setOrsayData", context);
      this.handleSaveOrsayData(context);
    }
    if(!DeviceType.isTizen && !DeviceType.isLG && !DeviceType.isOrsay) {
      console.log("=======================setDefaultData", context);
      this.saveLocalStorageData(context);
    }
    return Promise.resolve(context);
  }

  static get getData() {
    //console.log('ENV: ', process.env.NODE_ENV, window.bid, window.room, window.deviceId, window.tizen, window.isTizen, window.lang);
    if (window.bid && window.room && window.deviceId) {
      return {
        bid: window.bid,
        deviceId: window.deviceId,
        room: window.room,
      };
    }
    if (process.env.NODE_ENV !== 'production') {
      console.log('window:', window.bid, window.room, window.deviceId);
    }
    if (DeviceType.isTizen) {
      return this.getTizenData;
    }
    if (DeviceType.isLG) {
      //return this.getLGData;
      return this.getLocalStorage;
    }
    if (DeviceType.isOrsay) {
      return this.getOrsayData;
    }
    return this.getLocalStorage;
  }

  static removeData(options = defaultOptions) {
    console.log("+++++++++++++++++++++++++++++++++++++++++++++removeData", options);
    if(DeviceType.isTizen) {
      this.removeTizenData(options);
    } else if(DeviceType.isLG) {
      //this.removeLGData(options);
      this.removeLocalStorageData(options);
    } else if(DeviceType.isOrsay) {
      this.removeOrsayData(options);
    } else {
      this.removeLocalStorageData(options);
    }
  }


  static removeCookie(options = defaultOptions) {
    console.log("+++++++++++++++++++++++++++++++++++++++++++++removeCookie", options);
    /*
    if(DeviceType.isTizen) {
      this.removeTizenData(options);
    } else if(DeviceType.isLG) {
      //this.removeLGData(options);
      this.removeLocalStorageData(options);
    } else if(DeviceType.isOrsay) {
      this.removeOrsayData(options);
    } else {
      this.removeLocalStorageData(options);
    }
      */
    CookieStorage.remove('lang');
  }

  static async fetchBuildingInfo() {
    try {
      const response = await Requests.fetchBuildingId();
      if (!response.buildingId) return response;

      const savedData = await this.saveData({
        bid: response.buildingId,
      });
      response.serialNumber = savedData.serialNumber;

      const buildingDetails = await Requests.fetchBuildingDetails(
        response.buildingId
      );
      response.buildingDetails = buildingDetails;
      console.log('BUILDING DETAILS: ', buildingDetails, store);

      return Promise.resolve(response);
    } catch (err) {
      console.log('ERROR FETCH BUILDING INFO', err);
      return Promise.reject(err);
    }
  }

  /**
   * Prueft ob das Geraet anhand seines Fingerprints bereits in der DB registriert ist.
   * Gibt bei Treffer das Geraeteobjekt zurueck und speichert die Daten lokal.
   * Gibt null zurueck wenn kein Eintrag gefunden wurde.
   */
  static async tryAutoRegisterByFingerprint() {
    try {
      const [fingerprint, serialNumber, mac] = await Promise.all([
        new DeviceFingerprint().generateFingerprint(),
        Device.serialNumber,
        Device.mac,
      ]);
      const existingDevice = await Requests.fetchDeviceByFingerprint(fingerprint, { serialNumber, mac });
      if (!existingDevice || !existingDevice.id) return null;

      await this.saveData({
        deviceId: existingDevice.id,
        bid: existingDevice.buildingId,
        room: existingDevice.room,
        serialNumber: existingDevice.serialNumber,
      });
      return existingDevice;
    } catch (err) {
      console.log('[Registration] tryAutoRegisterByFingerprint failed:', err);
      return null;
    }
  }

  static async createDevice({ buildingId, groupId, room }) {
    console.log('CREATE INIT VALUES: ', {
      buildingId,
      groupId,
      room,
    });

    const [device, fingerprint] = await Promise.all([
      DeviceType.getDefaultDevice(),
      new DeviceFingerprint().generateFingerprint(),
    ]);

    // Fingerprint-Lookup: pruefen ob dieses TV bereits registriert war
    const existingDevice = await Requests.fetchDeviceByFingerprint(fingerprint, device);
    if (existingDevice && existingDevice.id) {
      console.log('[Registration] Geraet bereits registriert (Fingerprint match):', existingDevice.id);
      store.dispatch('notification/new', {
        title: 'Geraet wiedergefunden',
        message: `Bekanntes TV: DeviceId ${existingDevice.id}`,
      });
      const savedData = await this.saveData({
        deviceId: existingDevice.id,
        bid: existingDevice.buildingId || buildingId,
        room: existingDevice.room || room,
        serialNumber: existingDevice.serialNumber,
      });
      return Promise.resolve({
        buildingId: savedData.bid,
        room: savedData.room,
        deviceId: savedData.deviceId,
      });
    }

    // Kein bestehender Eintrag → neues Geraet anlegen
    device.buildingId = buildingId;
    device.groupId = groupId;
    device.room = room;
    device.fingerprint = fingerprint;
    console.log('=====================================createDevice', device);
    const deviceCreated = await Requests.postCreateDevice(device);
    store.dispatch('notification/new', {
      title: 'DEVICE INFO',
      message: `DeviceId: ${
        deviceCreated.id
      }, Type: ${typeof deviceCreated.id}`,
    });

    const savedData = await this.saveData({
      deviceId: deviceCreated.id,
      room,
      bid: buildingId,
      //resHeight: DeviceType.getResHeight,
      //resWidth: DeviceType.getResWidth,
    });

    const response = {
      buildingId: savedData.bid,
      room: savedData.room,
      deviceId: savedData.deviceId,
      //resHeight: savedData.resHight,
      //resWidth: savedData.resWidth,
    };
    return Promise.resolve(response);
  }
}

export default Registration;



// WEBPACK FOOTER //
// ./src/helpers/Registration.js